// import axios from "axios";
// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import ApiUrl from "../Environment/ApiUrl";
// import { useToast } from "../Toast/ToastContext";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import * as XLSX from "xlsx";

// // Purchase page now shows the list of SUPPLIERS with their current
// // (gram) balance and last purchase date, instead of a flat list of
// // purchase bills. Clicking a supplier row drills into
// // SupplierPurchaseHistory.js, which shows that supplier's purchase
// // id / purchase date / items etc. — i.e. everything this page used
// // to show directly.
// function Purchase() {
//   const toast = useToast();
//   const navigate = useNavigate();

//   const [loading, setLoading] = useState(false);
//   const [suppliers, setSuppliers] = useState([]);
//   const [purchases, setPurchases] = useState([]);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [showAllItems, setShowAllItems] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");

//   // ─── Helpers ──────────────────────────────────────────────────────────────

//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     try {
//       const date = new Date(dateString);
//       if (isNaN(date.getTime())) return dateString;
//       const day = String(date.getDate()).padStart(2, "0");
//       const month = String(date.getMonth() + 1).padStart(2, "0");
//       const year = date.getFullYear();
//       return `${day}-${month}-${year}`;
//     } catch (error) {
//       return dateString;
//     }
//   };

//   const getSupplierDisplayName = (supplier) => {
//     if (!supplier) return "";
//     if (supplier.name_tamil) {
//       return `${supplier.name} / ${supplier.name_tamil}`;
//     }
//     return supplier.name || "";
//   };

//   // ─── Data Fetching ────────────────────────────────────────────────────────

//   // `isBackground` is true for the periodic 5s refresh below — we still
//   // refetch so the list stays current, but we don't flip on the full-page
//   // loading overlay for it (that was making the page "reload"/flash every
//   // 5 seconds). The overlay now only shows for the very first load.
//   const fetchData = async (isBackground = false) => {
//     try {
//       if (!isBackground) setLoading(true);
//       const localRole = localStorage.getItem("role");
//       const localUsername = localStorage.getItem("username");

//       const [supplierRes, purchaseRes] = await Promise.all([
//         axios.get(`${ApiUrl}/Api/supplier.php`),
//         axios.get(
//           localRole === "Employee"
//             ? `${ApiUrl}/Api/purchase_details.php?employee_id=${localUsername}`
//             : `${ApiUrl}/Api/purchase_details.php`
//         ),
//       ]);

//       setSuppliers(supplierRes.data?.data || []);
//       setPurchases(purchaseRes.data?.data || []);
//     } catch (error) {
//       console.error("Error fetching data:", error.message);
//       if (!isBackground) {
//         setSuppliers([]);
//         setPurchases([]);
//       }
//       toast.error("Failed to fetch data", 3000, "topRight");
//     } finally {
//       if (!isBackground) setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData(false);
//     const interval = setInterval(() => fetchData(true), 5000);
//     return () => clearInterval(interval);
//   }, []);

//   // ─── Build supplier rows with balance + last purchase date ────────────────
//   // purchase_details.php's `close` field already carries the running,
//   // gram-based ledger balance for a supplier (see AddPurchase.js's
//   // "Opening balance logic" which reads it the same way). So the most
//   // recent purchase (by purchase_date) for a supplier tells us both its
//   // current balance and its last purchase date.

//   const supplierRows = suppliers
//     .map((supplier) => {
//       const supplierPurchases = purchases
//         .filter(
//           (p) =>
//             p.supplier_id &&
//             p.supplier_id.toString() === supplier.supplier_id?.toString()
//         )
//         .sort((a, b) => new Date(b.purchase_date) - new Date(a.purchase_date));

//       const latest = supplierPurchases[0] || null;

//       const totalAmount = supplierPurchases.reduce(
//         (sum, p) => sum + (parseFloat(p.enter_amount) || 0),
//         0
//       );
//       const totalPaid = supplierPurchases.reduce(
//         (sum, p) => sum + (parseFloat(p.paid) || 0),
//         0
//       );

//       return {
//         ...supplier,
//         balance: latest ? parseFloat(latest.close || 0) : 0,
//         lastPurchaseDate: latest ? latest.purchase_date : null,
//         purchaseCount: supplierPurchases.length,
//         totalAmount,
//         totalPaid,
//       };
//     })
//     // Only suppliers who have actually made at least one purchase should
//     // show up on this page — the rest just clutter the list.
//     .filter((supplier) => supplier.purchaseCount > 0);

//   // ─── Search / Pagination ────────────────────────────────────────────────

//   const filteredData = supplierRows.filter((item) => {
//     const searchLower = searchTerm.toLowerCase();
//     const nameText = getSupplierDisplayName(item).toLowerCase();
//     return (
//       nameText.includes(searchLower) ||
//       (item.supplier_id &&
//         item.supplier_id.toString().toLowerCase().includes(searchLower)) ||
//       (item.mobile && item.mobile.toString().includes(searchLower))
//     );
//   });

//   const totalItems = filteredData.length;
//   const totalPages = showAllItems ? 1 : Math.ceil(totalItems / itemsPerPage);

//   const currentItems = showAllItems
//     ? filteredData
//     : filteredData.slice(
//         (currentPage - 1) * itemsPerPage,
//         currentPage * itemsPerPage
//       );

//   const handlePageChange = (page) => {
//     if (page < 1 || page > totalPages) return;
//     setCurrentPage(page);
//   };

//   const handleItemsPerPageChange = (e) => {
//     const value = e.target.value;
//     if (value === "All") {
//       setShowAllItems(true);
//       setCurrentPage(1);
//     } else {
//       setShowAllItems(false);
//       setItemsPerPage(Number(value));
//       setCurrentPage(1);
//     }
//   };

//   const renderPageNumbers = () => {
//     const pages = [];
//     const maxVisiblePages = 2;
//     let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
//     let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

//     if (endPage - startPage + 1 < maxVisiblePages) {
//       startPage = Math.max(1, endPage - maxVisiblePages + 1);
//     }

//     if (startPage > 1) {
//       pages.push(
//         <li key={1} className={`page-item ${currentPage === 1 ? "active" : ""}`}>
//           <button className="page-link" onClick={() => handlePageChange(1)}>
//             1
//           </button>
//         </li>
//       );
//       if (startPage > 2) {
//         pages.push(
//           <li key="start-ellipsis" className="page-item disabled">
//             <span className="page-link">...</span>
//           </li>
//         );
//       }
//     }

//     for (let i = startPage; i <= endPage; i++) {
//       pages.push(
//         <li key={i} className={`page-item ${currentPage === i ? "active" : ""}`}>
//           <button className="page-link" onClick={() => handlePageChange(i)}>
//             {i}
//           </button>
//         </li>
//       );
//     }

//     if (endPage < totalPages) {
//       if (endPage < totalPages - 1) {
//         pages.push(
//           <li key="end-ellipsis" className="page-item disabled">
//             <span className="page-link">...</span>
//           </li>
//         );
//       }
//       pages.push(
//         <li
//           key={totalPages}
//           className={`page-item ${currentPage === totalPages ? "active" : ""}`}
//         >
//           <button
//             className="page-link"
//             onClick={() => handlePageChange(totalPages)}
//           >
//             {totalPages}
//           </button>
//         </li>
//       );
//     }

//     return pages;
//   };

//   // ─── Export / Print ──────────────────────────────────────────────────────

//   const exportRows = () =>
//     filteredData.map((item, index) => [
//       index + 1,
//       item.supplier_id || "",
//       getSupplierDisplayName(item),
//       item.mobile || "",
//       item.totalAmount.toFixed(2),
//       item.totalPaid.toFixed(2),
//       item.balance.toFixed(3),
//       item.lastPurchaseDate ? formatDate(item.lastPurchaseDate) : "-",
//     ]);

//   const exportHeaders = [
//     "S.No",
//     "Supplier ID",
//     "Supplier Name",
//     "Mobile",
//     "Total (₹)",
//     "Paid (₹)",
//     "Balance (g)",
//     "Last Purchase Date",
//   ];

//   const handlePrint = () => {
//     try {
//       const printWindow = window.open("", "_blank");
//       printWindow.document.write(`
//         <html>
//           <head>
//             <title>Supplier Purchase Balances</title>
//             <style>
//               body { font-family: Arial, sans-serif; margin: 20px; }
//               table { width: 100%; border-collapse: collapse; margin-top: 20px; }
//               th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
//               th { background-color: #f2f2f2; font-weight: bold; }
//               h1 { text-align: center; color: #333; }
//               .print-date { text-align: right; margin-bottom: 20px; font-size: 12px; }
//             </style>
//           </head>
//           <body>
//             <h1>Supplier Purchase Balances</h1>
//             <div class="print-date">Generated on: ${formatDate(new Date())}</div>
//             <table>
//               <thead>
//                 <tr>${exportHeaders.map((h) => `<th>${h}</th>`).join("")}</tr>
//               </thead>
//               <tbody>
//                 ${exportRows()
//                   .map(
//                     (row) =>
//                       `<tr>${row.map((cell) => `<td>${cell}</td>`).join("")}</tr>`
//                   )
//                   .join("")}
//               </tbody>
//             </table>
//             <script>
//               window.onload = function() { window.print(); window.close(); }
//             </script>
//           </body>
//         </html>
//       `);
//       printWindow.document.close();
//       toast.success("Print dialog opened!", 3000, "topRight");
//     } catch (error) {
//       console.error("Error printing:", error);
//       toast.error("Error printing. Please try again", 3000, "topRight");
//     }
//   };

//   const exportPDF = () => {
//     try {
//       const doc = new jsPDF();
//       doc.setFontSize(18);
//       doc.text("Supplier Purchase Balances", 14, 22);
//       doc.setFontSize(10);
//       doc.text(`Generated on: ${formatDate(new Date())}`, 14, 35);

//       autoTable(doc, {
//         head: [exportHeaders],
//         body: exportRows(),
//         startY: 45,
//         styles: { fontSize: 8, cellPadding: 3 },
//         headStyles: {
//           fillColor: [66, 139, 202],
//           textColor: 255,
//           fontStyle: "bold",
//         },
//       });

//       doc.save(`supplier-balances-${formatDate(new Date())}.pdf`);
//       toast.success("PDF exported successfully!", 3000, "topRight");
//     } catch (error) {
//       console.error("Error exporting PDF:", error);
//       toast.error("Error exporting PDF. Please try again.", 3000, "topRight");
//     }
//   };

//   const fallbackCopy = (text) => {
//     try {
//       const textArea = document.createElement("textarea");
//       textArea.value = text;
//       textArea.style.position = "fixed";
//       textArea.style.top = 0;
//       textArea.style.left = 0;
//       document.body.appendChild(textArea);
//       textArea.focus();
//       textArea.select();
//       const successful = document.execCommand("copy");
//       document.body.removeChild(textArea);
//       if (successful) {
//         toast.success("Data copied to clipboard!", 3000, "topRight");
//       } else {
//         toast.error("Failed to copy data", 3000, "topRight");
//       }
//     } catch (err) {
//       console.error("Fallback copy failed:", err);
//       toast.error("Failed to copy data", 3000, "topRight");
//     }
//   };

//   const copyToClipboard = () => {
//     try {
//       const csvData = [exportHeaders, ...exportRows()]
//         .map((row) => row.map((field) => `"${field}"`).join("\t"))
//         .join("\n");

//       if (navigator.clipboard && navigator.clipboard.writeText) {
//         navigator.clipboard
//           .writeText(csvData)
//           .then(() => toast.success("Data copied to clipboard!", 3000, "topRight"))
//           .catch((err) => {
//             console.error("Clipboard API failed:", err);
//             fallbackCopy(csvData);
//           });
//       } else {
//         fallbackCopy(csvData);
//       }
//     } catch (error) {
//       console.error("Unexpected error copying to clipboard:", error);
//       toast.error("Failed to copy data", 3000, "topRight");
//     }
//   };

//   const exportCSV = () => {
//     try {
//       const csvContent = [exportHeaders, ...exportRows()]
//         .map((row) =>
//           row
//             .map((field) =>
//               typeof field === "string" && field.includes(",")
//                 ? `"${field}"`
//                 : field
//             )
//             .join(",")
//         )
//         .join("\n");

//       const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//       const link = document.createElement("a");
//       const url = URL.createObjectURL(blob);
//       link.setAttribute("href", url);
//       link.setAttribute(
//         "download",
//         `supplier-balances-${formatDate(new Date())}.csv`
//       );
//       link.style.visibility = "hidden";
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       toast.success("CSV exported successfully!", 3000, "topRight");
//     } catch (error) {
//       console.error("Error exporting CSV:", error);
//       toast.error("Error exporting CSV. Please try again.", 3000, "topRight");
//     }
//   };

//   const exportExcel = () => {
//     try {
//       const worksheetData = [exportHeaders, ...exportRows()];
//       const workbook = XLSX.utils.book_new();
//       const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
//       worksheet["!cols"] = [
//         { wch: 8 },
//         { wch: 15 },
//         { wch: 30 },
//         { wch: 15 },
//         { wch: 15 },
//         { wch: 18 },
//       ];

//       XLSX.utils.book_append_sheet(workbook, worksheet, "Supplier Balances");
//       XLSX.writeFile(
//         workbook,
//         `supplier-balances-${formatDate(new Date())}.xlsx`
//       );
//       toast.success("Excel file exported successfully!", 3000, "topRight");
//     } catch (error) {
//       console.error("Error exporting Excel:", error);
//       toast.error("Error exporting Excel. Please try again.", 3000, "topRight");
//     }
//   };

//   // ─── Render ───────────────────────────────────────────────────────────────

//   return (
//     <>
//       {loading && (
//         <div className="loading-overlay">
//           <div className="loading-message">
//             <div className="loadinggif"></div>
//           </div>
//         </div>
//       )}

//       <div className="container-fluid">
//         <div className="d-flex mb-2">
//           <h6 className="card-title m-2">Purchase</h6>
//           <button
//             className="btn btn-primary btn-sm rounded-3"
//             onClick={() => navigate("/add-purchase")}
//           >
//             Add <span className="ms-2">+</span>
//           </button>
//         </div>

//         <div className="card shadow-sm mb-5">
//           <div className="card-body">
//             <div className="d-flex justify-content-between align-items-center mb-3">
//               <div className="d-flex">
//                 <label className="form-label text-dark mt-2">Show : </label>
//                 <div>
//                   <select
//                     className="form-control mx-2"
//                     onChange={handleItemsPerPageChange}
//                     value={showAllItems ? "All" : itemsPerPage}
//                   >
//                     <option value="All">All</option>
//                     {[5, 10, 20, 100, 200, 500, 1000].map((pageSize) => (
//                       <option key={pageSize} value={pageSize}>
//                         {pageSize}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>

//               <div className="d-flex justify-content-center">
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={handlePrint}
//                 >
//                   Print
//                 </button>
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={exportPDF}
//                 >
//                   PDF
//                 </button>
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={copyToClipboard}
//                 >
//                   Copy
//                 </button>
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={exportCSV}
//                 >
//                   CSV
//                 </button>
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={exportExcel}
//                 >
//                   Excel
//                 </button>
//               </div>

//               <div className="search-container">
//                 <div className="input-group">
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Search supplier"
//                     aria-label="Search"
//                     value={searchTerm}
//                     onChange={(e) => {
//                       setSearchTerm(e.target.value);
//                       setCurrentPage(1);
//                     }}
//                   />
//                 </div>
//               </div>
//             </div>

//             <div className="card tableCard p-2">
//               <div className="table-responsive">
//                 <table className="table">
//                   <thead className="bg-light">
//                     <tr>
//                       <th>S.No</th>
//                       <th>Supplier ID</th>
//                       <th style={{ minWidth: "200px" }}>Supplier Name</th>
//                       <th>Mobile</th>
//                       <th>Total (₹)</th>
//                       <th>Paid (₹)</th>
//                       <th>Balance (g)</th>
//                       <th>Last Purchase Date</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {currentItems.length > 0 ? (
//                       currentItems.map((item, index) => (
//                         <tr
//                           key={item.id || item.supplier_id}
//                           role="button"
//                           style={{ cursor: "pointer" }}
//                           onClick={() =>
//                             navigate(`/purchases/supplier/${item.supplier_id}`)
//                           }
//                         >
//                           <td>
//                             {showAllItems
//                               ? index + 1
//                               : (currentPage - 1) * itemsPerPage + index + 1}
//                           </td>
//                           <td>{item.supplier_id}</td>
//                           <td>{getSupplierDisplayName(item) || "-"}</td>
//                           <td>{item.mobile || "-"}</td>
//                           <td>₹{item.totalAmount.toFixed(2)}</td>
//                           <td>₹{item.totalPaid.toFixed(2)}</td>
//                           <td>{item.balance.toFixed(3)}</td>
//                           <td>
//                             {item.lastPurchaseDate
//                               ? formatDate(item.lastPurchaseDate)
//                               : "-"}
//                           </td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="8" className="text-center">
//                           No suppliers found
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>

//               <div className="row">
//                 <div className="col-lg-6">
//                   <p className="text-muted">
//                     Showing{" "}
//                     {showAllItems ? 1 : (currentPage - 1) * itemsPerPage + 1} to{" "}
//                     {showAllItems
//                       ? totalItems
//                       : Math.min(currentPage * itemsPerPage, totalItems)}{" "}
//                     of {totalItems} entries
//                   </p>
//                 </div>
//                 <div className="col-lg-6">
//                   <nav aria-label="Page navigation">
//                     <ul className="pagination justify-content-end">
//                       <li
//                         className={`page-item ${
//                           currentPage === 1 ? "disabled" : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(1)}
//                           aria-label="First"
//                         >
//                           <span aria-hidden="true">««</span>
//                         </button>
//                       </li>
//                       <li
//                         className={`page-item ${
//                           currentPage === 1 ? "disabled" : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(currentPage - 1)}
//                           aria-label="Previous"
//                         >
//                           <span aria-hidden="true">«</span>
//                         </button>
//                       </li>
//                       {renderPageNumbers()}
//                       <li
//                         className={`page-item ${
//                           currentPage === totalPages || totalPages === 0
//                             ? "disabled"
//                             : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(currentPage + 1)}
//                           aria-label="Next"
//                         >
//                           <span aria-hidden="true">»</span>
//                         </button>
//                       </li>
//                       <li
//                         className={`page-item ${
//                           currentPage === totalPages || totalPages === 0
//                             ? "disabled"
//                             : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(totalPages)}
//                           aria-label="Last"
//                         >
//                           <span aria-hidden="true">»»</span>
//                         </button>
//                       </li>
//                     </ul>
//                   </nav>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default Purchase;



import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiUrl from "../Environment/ApiUrl";
import { useToast } from "../Toast/ToastContext";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

// Purchase page now shows the list of SUPPLIERS with their current
// (gram) balance and last purchase date, instead of a flat list of
// purchase bills. Clicking a supplier row drills into
// SupplierPurchaseHistory.js, which shows that supplier's purchase
// id / purchase date / items etc. — i.e. everything this page used
// to show directly.
function Purchase() {
  const toast = useToast();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [suppliers, setSuppliers] = useState([]);
  const [purchases, setPurchases] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showAllItems, setShowAllItems] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  // ─── Helpers ──────────────────────────────────────────────────────────────

  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    } catch (error) {
      return dateString;
    }
  };

  const getSupplierDisplayName = (supplier) => {
    if (!supplier) return "";
    if (supplier.name_tamil) {
      return `${supplier.name} / ${supplier.name_tamil}`;
    }
    return supplier.name || "";
  };

  // ─── Data Fetching ────────────────────────────────────────────────────────

  // `isBackground` is true for the periodic 5s refresh below — we still
  // refetch so the list stays current, but we don't flip on the full-page
  // loading overlay for it (that was making the page "reload"/flash every
  // 5 seconds). The overlay now only shows for the very first load.
  const fetchData = async (isBackground = false) => {
    try {
      if (!isBackground) setLoading(true);
      const localRole = localStorage.getItem("role");
      const localUsername = localStorage.getItem("username");

      const [supplierRes, purchaseRes] = await Promise.all([
        axios.get(`${ApiUrl}/Api/supplier.php`),
        axios.get(
          localRole === "Employee"
            ? `${ApiUrl}/Api/purchase_details.php?employee_id=${localUsername}`
            : `${ApiUrl}/Api/purchase_details.php`
        ),
      ]);

      setSuppliers(supplierRes.data?.data || []);
      setPurchases(purchaseRes.data?.data || []);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      if (!isBackground) {
        setSuppliers([]);
        setPurchases([]);
      }
      toast.error("Failed to fetch data", 3000, "topRight");
    } finally {
      if (!isBackground) setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(false);
    const interval = setInterval(() => fetchData(true), 5000);
    return () => clearInterval(interval);
  }, []);

  // ─── Build supplier rows with balance + last purchase date ────────────────
  // purchase_details.php's `close` field already carries the running,
  // gram-based ledger balance for a supplier (see AddPurchase.js's
  // "Opening balance logic" which reads it the same way). So the most
  // recent purchase (by purchase_date) for a supplier tells us both its
  // current balance and its last purchase date.

  const supplierRows = suppliers
    .map((supplier) => {
      const supplierPurchases = purchases
        .filter(
          (p) =>
            p.supplier_id &&
            p.supplier_id.toString() === supplier.supplier_id?.toString()
        )
        .sort((a, b) => new Date(b.purchase_date) - new Date(a.purchase_date));

      const latest = supplierPurchases[0] || null;

      const totalAmount = supplierPurchases.reduce(
        (sum, p) => sum + (parseFloat(p.enter_amount) || 0),
        0
      );
      const totalPaid = supplierPurchases.reduce(
        (sum, p) => sum + (parseFloat(p.paid) || 0),
        0
      );
      // `total_pure` on each purchase is the pure-gram value of the goods
      // bought in that purchase.
      // `pure` holds a value for every purchase (AddPurchase.js's
      // preparePayload() always fills it in), but it only reflects an
      // actual pure-gram payment when that purchase's return_type is
      // "Pure" — when return_type is "Amount" it's just the gram
      // equivalent of the cash `paid` amount at that day's rate, not a
      // separate payment. So "Total Paid Pure" only sums `pure` for
      // Pure-return purchases, matching totalPaid which already only
      // sums `paid` for Amount-return purchases (it's 0 otherwise).
      const totalPure = supplierPurchases.reduce(
        (sum, p) => sum + (parseFloat(p.total_pure) || 0),
        0
      );
      const totalPaidPure = supplierPurchases.reduce(
        (sum, p) =>
          sum + (p.return_type === "Pure" ? parseFloat(p.pure) || 0 : 0),
        0
      );

      return {
        ...supplier,
        balance: latest ? parseFloat(latest.close || 0) : 0,
        lastPurchaseDate: latest ? latest.purchase_date : null,
        purchaseCount: supplierPurchases.length,
        totalAmount,
        totalPaid,
        totalPure,
        totalPaidPure,
      };
    })
    // Only suppliers who have actually made at least one purchase should
    // show up on this page — the rest just clutter the list.
    .filter((supplier) => supplier.purchaseCount > 0);

  // ─── Search / Pagination ────────────────────────────────────────────────

  const filteredData = supplierRows.filter((item) => {
    const searchLower = searchTerm.toLowerCase();
    const nameText = getSupplierDisplayName(item).toLowerCase();
    return (
      nameText.includes(searchLower) ||
      (item.supplier_id &&
        item.supplier_id.toString().toLowerCase().includes(searchLower)) ||
      (item.mobile && item.mobile.toString().includes(searchLower))
    );
  });

  const totalItems = filteredData.length;
  const totalPages = showAllItems ? 1 : Math.ceil(totalItems / itemsPerPage);

  const currentItems = showAllItems
    ? filteredData
    : filteredData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      );

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (e) => {
    const value = e.target.value;
    if (value === "All") {
      setShowAllItems(true);
      setCurrentPage(1);
    } else {
      setShowAllItems(false);
      setItemsPerPage(Number(value));
      setCurrentPage(1);
    }
  };

  const renderPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 2;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    if (startPage > 1) {
      pages.push(
        <li key={1} className={`page-item ${currentPage === 1 ? "active" : ""}`}>
          <button className="page-link" onClick={() => handlePageChange(1)}>
            1
          </button>
        </li>
      );
      if (startPage > 2) {
        pages.push(
          <li key="start-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li key={i} className={`page-item ${currentPage === i ? "active" : ""}`}>
          <button className="page-link" onClick={() => handlePageChange(i)}>
            {i}
          </button>
        </li>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push(
          <li key="end-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
      pages.push(
        <li
          key={totalPages}
          className={`page-item ${currentPage === totalPages ? "active" : ""}`}
        >
          <button
            className="page-link"
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </button>
        </li>
      );
    }

    return pages;
  };

  // ─── Export / Print ──────────────────────────────────────────────────────

  const exportRows = () =>
    filteredData.map((item, index) => [
      index + 1,
      item.supplier_id || "",
      getSupplierDisplayName(item),
      item.mobile || "",
      item.totalAmount.toFixed(2),
      item.totalPure.toFixed(3),
      item.totalPaid.toFixed(2),
      item.totalPaidPure.toFixed(3),
      item.balance.toFixed(3),
      item.lastPurchaseDate ? formatDate(item.lastPurchaseDate) : "-",
    ]);

  const exportHeaders = [
    "S.No",
    "Supplier ID",
    "Supplier Name",
    "Mobile",
    // "Total (₹)",
    "Total Pure (g)",
    "Paid (₹)",
    "Total Paid Pure (g)",
    "Balance (g)",
    "Last Purchase Date",
  ];

  const handlePrint = () => {
    try {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
        <html>
          <head>
            <title>Supplier Purchase Balances</title>
            <style>
              body { font-family: Arial, sans-serif; margin: 20px; }
              table { width: 100%; border-collapse: collapse; margin-top: 20px; }
              th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
              th { background-color: #f2f2f2; font-weight: bold; }
              h1 { text-align: center; color: #333; }
              .print-date { text-align: right; margin-bottom: 20px; font-size: 12px; }
            </style>
          </head>
          <body>
            <h1>Supplier Purchase Balances</h1>
            <div class="print-date">Generated on: ${formatDate(new Date())}</div>
            <table>
              <thead>
                <tr>${exportHeaders.map((h) => `<th>${h}</th>`).join("")}</tr>
              </thead>
              <tbody>
                ${exportRows()
                  .map(
                    (row) =>
                      `<tr>${row.map((cell) => `<td>${cell}</td>`).join("")}</tr>`
                  )
                  .join("")}
              </tbody>
            </table>
            <script>
              window.onload = function() { window.print(); window.close(); }
            </script>
          </body>
        </html>
      `);
      printWindow.document.close();
      toast.success("Print dialog opened!", 3000, "topRight");
    } catch (error) {
      console.error("Error printing:", error);
      toast.error("Error printing. Please try again", 3000, "topRight");
    }
  };

  const exportPDF = () => {
    try {
      const doc = new jsPDF();
      doc.setFontSize(18);
      doc.text("Supplier Purchase Balances", 14, 22);
      doc.setFontSize(10);
      doc.text(`Generated on: ${formatDate(new Date())}`, 14, 35);

      autoTable(doc, {
        head: [exportHeaders],
        body: exportRows(),
        startY: 45,
        styles: { fontSize: 8, cellPadding: 3 },
        headStyles: {
          fillColor: [66, 139, 202],
          textColor: 255,
          fontStyle: "bold",
        },
      });

      doc.save(`supplier-balances-${formatDate(new Date())}.pdf`);
      toast.success("PDF exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error exporting PDF:", error);
      toast.error("Error exporting PDF. Please try again.", 3000, "topRight");
    }
  };

  const fallbackCopy = (text) => {
    try {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.top = 0;
      textArea.style.left = 0;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      const successful = document.execCommand("copy");
      document.body.removeChild(textArea);
      if (successful) {
        toast.success("Data copied to clipboard!", 3000, "topRight");
      } else {
        toast.error("Failed to copy data", 3000, "topRight");
      }
    } catch (err) {
      console.error("Fallback copy failed:", err);
      toast.error("Failed to copy data", 3000, "topRight");
    }
  };

  const copyToClipboard = () => {
    try {
      const csvData = [exportHeaders, ...exportRows()]
        .map((row) => row.map((field) => `"${field}"`).join("\t"))
        .join("\n");

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(csvData)
          .then(() => toast.success("Data copied to clipboard!", 3000, "topRight"))
          .catch((err) => {
            console.error("Clipboard API failed:", err);
            fallbackCopy(csvData);
          });
      } else {
        fallbackCopy(csvData);
      }
    } catch (error) {
      console.error("Unexpected error copying to clipboard:", error);
      toast.error("Failed to copy data", 3000, "topRight");
    }
  };

  const exportCSV = () => {
    try {
      const csvContent = [exportHeaders, ...exportRows()]
        .map((row) =>
          row
            .map((field) =>
              typeof field === "string" && field.includes(",")
                ? `"${field}"`
                : field
            )
            .join(",")
        )
        .join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `supplier-balances-${formatDate(new Date())}.csv`
      );
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success("CSV exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error exporting CSV:", error);
      toast.error("Error exporting CSV. Please try again.", 3000, "topRight");
    }
  };

  const exportExcel = () => {
    try {
      const worksheetData = [exportHeaders, ...exportRows()];
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
      worksheet["!cols"] = [
        { wch: 8 },
        { wch: 15 },
        { wch: 30 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 18 },
        { wch: 15 },
        { wch: 18 },
      ];

      XLSX.utils.book_append_sheet(workbook, worksheet, "Supplier Balances");
      XLSX.writeFile(
        workbook,
        `supplier-balances-${formatDate(new Date())}.xlsx`
      );
      toast.success("Excel file exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error exporting Excel:", error);
      toast.error("Error exporting Excel. Please try again.", 3000, "topRight");
    }
  };

  // ─── Render ───────────────────────────────────────────────────────────────

  return (
    <>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-message">
            <div className="loadinggif"></div>
          </div>
        </div>
      )}

      <div className="container-fluid">
        <div className="d-flex mb-2">
          <h6 className="card-title m-2">Purchase</h6>
          <button
            className="btn btn-primary btn-sm rounded-3"
            onClick={() => navigate("/add-purchase")}
          >
            Add <span className="ms-2">+</span>
          </button>
        </div>

        <div className="card shadow-sm mb-5">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="d-flex">
                <label className="form-label text-dark mt-2">Show : </label>
                <div>
                  <select
                    className="form-control mx-2"
                    onChange={handleItemsPerPageChange}
                    value={showAllItems ? "All" : itemsPerPage}
                  >
                    <option value="All">All</option>
                    {[5, 10, 20, 100, 200, 500, 1000].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="d-flex justify-content-center">
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={handlePrint}
                >
                  Print
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportPDF}
                >
                  PDF
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={copyToClipboard}
                >
                  Copy
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportCSV}
                >
                  CSV
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportExcel}
                >
                  Excel
                </button>
              </div>

              <div className="search-container">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search supplier"
                    aria-label="Search"
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="card tableCard p-2">
              <div className="table-responsive">
                <table className="table">
                  <thead className="bg-light">
                    <tr>
                      <th>S.No</th>
                      <th>Supplier ID</th>
                      <th style={{ minWidth: "200px" }}>Supplier Name</th>
                      <th>Mobile</th>
                      {/* <th>Total (₹)</th> */}
                      <th>Total Pure (g)</th>
                      <th>Paid (₹)</th>
                      <th>Total Paid Pure (g)</th>
                      <th>Balance (g)</th>
                      <th>Last Purchase Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.length > 0 ? (
                      currentItems.map((item, index) => (
                        <tr
                          key={item.id || item.supplier_id}
                          role="button"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            navigate(`/purchases/supplier/${item.supplier_id}`)
                          }
                        >
                          <td>
                            {showAllItems
                              ? index + 1
                              : (currentPage - 1) * itemsPerPage + index + 1}
                          </td>
                          <td>{item.supplier_id}</td>
                          <td>{getSupplierDisplayName(item) || "-"}</td>
                          <td>{item.mobile || "-"}</td>
                          {/* <td>₹{item.totalAmount.toFixed(2)}</td> */}
                          <td>{item.totalPure.toFixed(3)}g</td>
                          <td>₹{item.totalPaid.toFixed(2)}</td>
                          <td>{item.totalPaidPure.toFixed(3)}g</td>
                          <td>{item.balance.toFixed(3)}</td>
                          <td>
                            {item.lastPurchaseDate
                              ? formatDate(item.lastPurchaseDate)
                              : "-"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="10" className="text-center">
                          No suppliers found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <div className="row">
                <div className="col-lg-6">
                  <p className="text-muted">
                    Showing{" "}
                    {showAllItems ? 1 : (currentPage - 1) * itemsPerPage + 1} to{" "}
                    {showAllItems
                      ? totalItems
                      : Math.min(currentPage * itemsPerPage, totalItems)}{" "}
                    of {totalItems} entries
                  </p>
                </div>
                <div className="col-lg-6">
                  <nav aria-label="Page navigation">
                    <ul className="pagination justify-content-end">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(1)}
                          aria-label="First"
                        >
                          <span aria-hidden="true">««</span>
                        </button>
                      </li>
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage - 1)}
                          aria-label="Previous"
                        >
                          <span aria-hidden="true">«</span>
                        </button>
                      </li>
                      {renderPageNumbers()}
                      <li
                        className={`page-item ${
                          currentPage === totalPages || totalPages === 0
                            ? "disabled"
                            : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage + 1)}
                          aria-label="Next"
                        >
                          <span aria-hidden="true">»</span>
                        </button>
                      </li>
                      <li
                        className={`page-item ${
                          currentPage === totalPages || totalPages === 0
                            ? "disabled"
                            : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(totalPages)}
                          aria-label="Last"
                        >
                          <span aria-hidden="true">»»</span>
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Purchase;